import * as React from "react";
import apiClients from "../../apiClients";
import * as Messages from "../../codegen/Messages";
import { parseId } from "../../helpers/idHelper";
import { useMutationCall } from "../../hooks/useMutationCall";
import {
  AsyncNotificationMethodKey,
  AsyncNotificationPolledResponseKey,
  MDS_STOP_POLL_DELAY,
  MDS_STOP_POLL_INTERVAL,
} from "../../models/AsyncNotificationProviders";
import { getOciRegion } from "../../utils";
import { OperationConfirmationProps } from "../OperationTypes";

export interface MysqlStopProps extends OperationConfirmationProps {
  databaseId: string | undefined;
}

const MysqlStop = (
  { location, databaseId, onExecute }: MysqlStopProps,
): JSX.Element => {
  const { invokeCall: invokeStop } = useMutationCall(
    { method: apiClients.withRegion(getOciRegion(location)).mdsDatabaseApi.stopMdsDbSystem },
  );

  React.useEffect(() => {
    const { subscriptionId, resourceGroup, resourceName } = parseId(databaseId);
    const resourceGroupName = decodeURIComponent(resourceGroup || "");
    const dbSystemName = decodeURIComponent(resourceName || "");

    const invokeOptions = {
      onSuccess: onExecute,
      notification: {
        inProgress: {
          title: Messages.notifications.inProgress.titles.stopMysql(),
          message: Messages.notifications.inProgress.messages.stopMysql(dbSystemName),
        },
        success: {
          title: Messages.notifications.success.titles.stopMysql(),
          message: Messages.notifications.success.messages.stopMysql(dbSystemName),
        },
        failure: {
          title: Messages.notifications.failure.titles.stop(),
          message: Messages.notifications.failure.messages.stopMysql(dbSystemName),
        },
        asyncPolling: {
          methodKey: AsyncNotificationMethodKey.MDS_GET,
          methodArgs: {
            subscriptionId,
            resourceGroupName,
            dbSystemName,
          },
          location,
          responseMethodKey: AsyncNotificationPolledResponseKey.MDS_STOPPED_CHECK,
          delay: MDS_STOP_POLL_DELAY,
          interval: MDS_STOP_POLL_INTERVAL,
        },
      },
    };
    invokeStop({
      subscriptionId,
      resourceGroupName,
      dbSystemName,
    }, invokeOptions);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div />;
};

export const newMysqlStop = (
  props: MysqlStopProps,
): JSX.Element => (<MysqlStop {...props} />);
